import { render, staticRenderFns } from "./i4pro.vue?vue&type=template&id=9e92e458&scoped=true"
import script from "./i4pro.vue?vue&type=script&lang=js"
export * from "./i4pro.vue?vue&type=script&lang=js"
import style0 from "./i4pro.vue?vue&type=style&index=0&id=9e92e458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e92e458",
  null
  
)

export default component.exports